import { Currencies } from '@orbital/games-frontend-library'
import React from 'react'

const combinations = [
  '',
  'High Card',
  'Pair',
  'Two Pairs',
  'Three of a kind',
  'Straight',
  'Flush',
  'Full House',
  'Four of a kind',
  'Straight Flush',
  'Royal Flush',
]

const addChipsToAnte = () => (
  <>
    ADD CHIPS TO<span>ANTE</span>
  </>
)

const aaBonusIsOptional = () => (
  <>
    AA BONUS IS<span>OPTIONAL</span>
  </>
)
const addChipsToAAbonus = () => (
  <>
    ADD CHIPS TO<span>AA BONUS</span>
  </>
)
const anteIsRequired = () => (
  <>
    ANTE IS<span>REQUIRED</span>
  </>
)

const playerTextBetReply = (
  type: number,
  precision: number,
  currency?: string,
  winAmount?: string,
  state?: number,
) => (
  <>
    {combinations[type]}
    {state === 5 && (
      <span>
        wins {Currencies[currency]}
        {winAmount && (+winAmount).toFixed(precision)}
      </span>
    )}
  </>
)
const dealerTextBetReply = (type: number, state: number) => (
  <>
    {combinations[type]}
    {type !== 0 && state === 6 && <span>wins</span>}
  </>
)

const resultText = (
  aaWin: string,
  showAAWin: boolean,
  type: number,
  precision: number,
  currency?: string,
  winAmount?: string,
  state?: number,
) => (
  <>
    {state === 11 ? (
      <p>Tie</p>
    ) : (
      <>
        <p>
          {combinations[type]}
          {state !== 4 && <span>wins</span>}
          {state === 5 && (
            <span>
              {Currencies[currency]}
              {winAmount && (+winAmount).toFixed(precision)}
            </span>
          )}
        </p>
        {showAAWin && (
          <p>
            AA Bonus
            <span>
              {Currencies[currency]}
              {(+aaWin).toFixed(precision)}
            </span>
          </p>
        )}
      </>
    )}
  </>
)

const empty = () => <span> </span>

export const texts = {
  addChipsToAnte,
  aaBonusIsOptional,
  addChipsToAAbonus,
  anteIsRequired,
  empty,
  resultText,
  dealerTextBetReply,
  playerTextBetReply,
}
